<link rel="ractive" href="../r-page.html">
<link rel="ractive" href="../components/collection.html" name="c-collection">
<link rel="ractive" href="../components/header.html" name="c-header">
<link rel="ractive" href="../components/footer.html" name="c-footer">
<link rel="ractive" href="../components/notification.html" name="c-notification">
<link rel="ractive" href="../components/package.html" name="c-package">
<link rel="ractive" href="../components/slider.html" name="c-slider">
<link rel="ractive" href="../components/slide.html" name="c-slide">
<link rel="ractive" href="../components/search-compact.html" name="c-search-compact">

<r-page
	noYield="{{noYield}}"
	title="{{title}}"
	description="{{description}}"
	openGraphImage="{{#if type === 'npm'}}{{@shared.serverHost}}/open-graph/image/npm/{{name}}{{/if}}"
>
	{{#partial seo}}
		{{#if packageNotFound}}
			<meta name="robots" content="noindex">
		{{/if}}

		<script type="application/ld+json">
			{{@shared.escape(JSON.stringify(microdata))}}
		</script>
	{{/partial}}

	{{#partial css}}
		<link rel="preconnect" href="https://ofcncog2cu-dsn.algolia.net/" crossorigin="anonymous">
		<link rel="preconnect" href="https://data.jsdelivr.com/" crossorigin="anonymous">
	{{/partial}}

	<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/pace-js@1.2.4/themes/orange/pace-theme-minimal.css" media="print" onload="this.media='all'">
	<script async data-pace-options='{ "restartOnPushState": false, "restartOnRequestAfter": false }' src="https://cdn.jsdelivr.net/npm/pace-js@1.2.4/pace.min.js"></script>

	<c-notification></c-notification>

	<c-header name={{name}} searchOpened="{{searchOpened}}">
		<c-search-compact __ready="{{__ready}}" searchOpened="{{searchOpened}}" page="{{page}}" query="{{query}}"></c-search-compact>
	</c-header>

	<div class="p-package page">
		<c-slider active="{{activeSlide}}">
			<c-slide>
				{{#if packageNotFound}}
					<div class="text-center package-not-found">
						Package {{name}} was not found.<br>
						Please retry in a few minutes and if the problem persists,
						file an issue on <a rel="noopener noreferrer" target="_blank" href="https://github.com/jsdelivr/www.jsdelivr.com/issues">GitHub</a>.
					</div>
				{{elseif packageFailedToLoad}}
					<div class="text-center package-not-found">
						Package {{name}} failed to load.<br>
						There might be a problem with your internet connection. Try refreshing the page a few times.<br>
						If the problem persists, file an issue on <a rel="noopener noreferrer" target="_blank" href="https://github.com/jsdelivr/www.jsdelivr.com/issues">GitHub</a>.
					</div>
				{{elseif package}}
					<c-package
						type="{{type}}"
						name="{{name}}"
						path="{{pathA}}"
						package="{{package}}"
						packageVersionsList="{{packageVersionsList}}"
						versionP="{{versionP}}"
						collection="{{collection}}"
						query="{{query}}"
						packageVersionsNotFound="{{packageVersionsNotFound}}"
						tabRoute="{{tabRoute}}">
					</c-package>
				{{/if}}
			</c-slide>

			<c-slide>
				<c-collection name="{{name}}" collection="{{collection}}"></c-collection>
			</c-slide>
		</c-slider>
	</div>

	<c-footer></c-footer>
</r-page>

<script>
	const has = require('../../assets/js/utils/has');
	const search = require('../../assets/js/utils/search');
	const http = require('../../assets/js/utils/http');

	component.exports = {
		computed: {
			tab: {
				get () {
					return this.get('tabRoute') !== 'readme' ? this.get('tabRoute') : '';
				},
				set (value = 'readme') {
					this.set('tabRoute', value);
				},
			},
			path: {
				get () {
					return this.get('pathA').join('/');
				},
				set (value = '') {
					this.set('pathA', value.split('/').filter(v => v));
				},
			},
			title () {
				return this.get('name') + ' CDN by jsDelivr - A CDN for npm and GitHub';
			},
			description () {
				return this.get('package.description') ? `A free, fast, and reliable CDN for ${this.get('name')}. ${this.get('package.description')}` : undefined;
			},
			version: {
				get () {
					return !this.get('versionS') || this.get('versionS') === this.get('versionP') ? '' : this.get('versionP');
				},
				set (value) {
					this.set({ versionS: true, versionP: value });
				},
			},
			microdata: {
				get () {
					return {
						'@context': 'https://schema.org',
						'@type': 'SoftwareSourceCode',
						'name': this.get('name'),
						'version': this.get('versionP'),
						'description': this.get('description'),
						'url': `https://www.jsdelivr.com/package/${this.get('type')}/${this.get('name')}`,
						'codeRepository': this.get('package.repository.url'),
						'dateCreated': Object.values(this.get('package.versions') || {}).at(0),
						'dateModified': Object.values(this.get('package.versions') || {}).at(-1),
						'programmingLanguage': 'JavaScript',
						'maintainer': {
							'@type': 'Person',
							'name': this.get('package.owner.name'),
						},
						'image': this.get('package.owner.avatar'),
					};
				},
			},
		},
		data () {
			return {
				collection: [],
				package: {},
				pathA: [],
			};
		},
		oninit () {
			this.set('activeSlide', this.get('slide') === 'collection' ? 1 : 0);

			this.observe('slide', (newValue) => {
				this.findComponent('c-slider').show(newValue === 'collection' ? 1 : 0);
			}, { init: false });

			this.observe('activeSlide', (newValue) => {
				this.set('slide', newValue ? 'collection' : '');
			}, { init: false });

			this.observe('versionP', (newValue) => {
				if (newValue && !this.get('versionS')) {
					this.set('versionS', newValue);
				}
			});

			// Support scoped npm packages.
			this.observe('scope name', () => {
				if (this.get('scope') && this.get('name') && this.get('name').indexOf(this.get('scope')) !== 0) {
					this.set('name', this.get('scope') + '/' + this.get('name'));
				}
			});

			// Convert user/repo to name for GitHub packages.
			this.observe('user repo', () => {
				if (this.get('user') && this.get('repo')) {
					this.set('name', this.get('user') + '/' + this.get('repo'));
				}
			});

			if (this.get('type') !== 'npm') {
				this.set({
					package: {
						githubRepo: {
							user: this.get('user'),
							project: this.get('repo'),
						},
						owner: {
							link: `https://github.com/${this.get('user')}/`,
							avatar: `https://github.com/${this.get('user')}.png`,
							name: this.get('user'),
						},
						readme: ' ',
					},
				}, { deep: true });
			}

			if (!Ractive.isServer) {
				this.observe('version', (version) => {
					http.fetchPackageReadme(this.get('type'), this.get('name'), version).then((readme) => {
						if (readme && version === this.get('version')) {
							this.set('package.readme', readme);
						}
					});
				}, { init: false });

				Promise.all([
					Object.keys(this.get('package')).length ? this.get('package') : search.getByName(this.get('name')),
					http.fetchPackageVersions(this.get('type'), this.get('name')),
					http.fetchPackageReadme(this.get('type'), this.get('name'), this.get('version')).catch(() => ''),
				]).then(([ result, versionsResponse, readme ]) => {
					let versionsArr = versionsResponse.versions.map(item => item.version);

					// This can only happen for GitHub packages.
					if (versionsResponse.versions.length === 0) {
						http.fetchProjectCommits(this.get('package.githubRepo.user'), this.get('package.githubRepo.project')).then((data) => {
							let sha = data[0].sha; // if there are no commits this will throw and trigger the catch() block, which is intended
							this.set('packageVersionsList', [ sha ]);
							this.set('package.githubRepo.head', sha);
							this.set('package.version', sha);
							this.set('versionP', sha);
						}).catch((error) => {
							this.set({ packageVersionsNotFound: true });
							this.set('package.githubRepo.head', 'HEAD');
							console.error(`Commits not found.`, error);
						});
					} else {
						let sortedVersionsArr = versionsArr.reduce((acc, version) => {
							if (version.indexOf('-') !== -1) {
								acc.prerelease.push(version);
							} else {
								acc.stable.push(version);
							}

							return acc;
						}, { stable: [], prerelease: [] });

						this.set('packageVersionsList', [
							...sortedVersionsArr.stable,
							'separator',
							...sortedVersionsArr.prerelease,
						]);

						if (versionsResponse.tags.latest && !app.router.route.getState().qs.version) {
							result.version = versionsResponse.tags.latest;
							this.set({ versionP: result.version, versionS: result.version });
						}

						// Set version for GitHub packages.
						if (!result.version) {
							result.version = versionsResponse.versions[0].version;
							result.githubRepo.head = versionsResponse.versions[0].version;
						}

						// Set version for GitHub packages or when an invalid version is selected.
						if (!this.get('versionP') || versionsArr.indexOf(this.get('versionP')) === -1) {
							this.set('versionP', versionsResponse.versions[0].version);
						}
					}

					this.set({ package: { ...result, readme } });
				}).catch((error) => {
					if (error.statusCode === 404 || error.status === 404) {
						this.set({ packageNotFound: true });
					} else {
						this.set({ packageFailedToLoad: true });
					}

					console.error(error);
				});

				if (has.localStorage()) {
					this.observe('collection', (newValue) => {
						localStorage.setItem('collection2', JSON.stringify(newValue));
					}, { init: false });
				}
			}
		},
	};
</script>
